export default __webpack_public_path__ + "static/media/affinity_solutions.05dd082a.png";